var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.2654,
    cy: 17,
    rx: 16.2654,
    ry: 16.2654,
    fill: "#7B61FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3991 20.1033C21.3991 21.9823 19.9945 23.6146 16.9957 23.8613V26.0061H15.781V23.8613C13.9209 23.7664 12.1558 23.1211 11.1688 22.21L11.8711 20.7296C12.7631 21.5457 14.2436 22.1531 15.781 22.248V17.8446C13.6932 17.3322 11.4915 16.6679 11.4915 14.0866C11.4915 12.2076 12.8391 10.5753 15.781 10.3285V8.1648H16.9957V10.3095C18.4192 10.3665 19.8427 10.784 20.8486 11.4673L20.2223 12.9857C19.1974 12.3404 18.0586 11.9798 16.9957 11.9229V16.3452C19.1215 16.8766 21.3991 17.503 21.3991 20.1033ZM13.3515 14.0107C13.3515 15.1874 14.4144 15.6809 15.781 16.0415V11.9418C14.0917 12.1506 13.3515 13.0047 13.3515 14.0107ZM16.9957 22.229C18.7608 22.0582 19.539 21.2421 19.539 20.2171C19.539 19.0024 18.4002 18.5279 16.9957 18.1483V22.229Z",
    fill: "#CEC5FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.17cc5ca4a02013875192e43866a980a1.svg";
export { ForwardRef as ReactComponent };